/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }

    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      // Infinite scroll duplicate prevention
      // If a loaded product is flagged to replace another (has corresponding ID),
      // we must drop the target if it already exists, or if it's already in the newly requested batch.
      let existingProducts = Array.from(this.grid.querySelectorAll('.column'));

      let productsToAppend = [];
      let idsToSkip = new Set();


      // Build list of IDs to skip from whatever is ALREADY in the grid
      existingProducts.forEach((prod) => {
        const corrId = prod.getAttribute('data-corresponding-product-id');
        if (corrId) idsToSkip.add(corrId);
      });

      // Only append fetched products if they shouldn't be skipped
      for (let i = 0; i < products.length; i++) {
        const prod = products[i];
        const prodId = prod.getAttribute('data-product-id');
        const corrId = prod.getAttribute('data-corresponding-product-id');

        // Skip it if it's an original product that has a custom version anywhere
        if (prodId && idsToSkip.has(prodId)) {
          continue;
        }

        if (corrId) idsToSkip.add(corrId);

        productsToAppend.push(prod);
        this.grid.appendChild(prod);
      }

      if (this.animations_enabled) {
        gsap.set(productsToAppend, {
          opacity: 0,
          y: 30
        });
        gsap.to(productsToAppend, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
            if (typeof StampedFn !== "undefined" && typeof StampedFn?.loadBadges !== "undefined") {
              StampedFn.loadBadges();
            }
          }
        });
      } else {
        base.removeAttribute('loading');
        if (typeof StampedFn !== "undefined" && typeof StampedFn?.loadBadges !== "undefined") {
          StampedFn.loadBadges();
        }
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}